import React, { useState,createContext } from "react";

export const ColorHeaderContext = createContext();

export const ColorHeaderProvider = ({ children }) => {
  const [colorHeader, setColorHeader] = useState('');
  const [colorSidebar, setColorSidebar] = useState('');
  const [colorFooter, setColorFooter] = useState('');
  const [colorBg, setColorBg] = useState('');

  const contextValue = {
    colorHeader, setColorHeader,
    colorSidebar, setColorSidebar,
    colorFooter, setColorFooter,
    colorBg, setColorBg
  };

  return (
    <ColorHeaderContext.Provider value={contextValue}>
      {children}
    </ColorHeaderContext.Provider>
  );
};
